import React, { useState, useEffect } from "react"

import { graphql, StaticQuery, Link, navigate } from "gatsby"

import appStoreSVG from "../../../../static/assets/images/app_store.svg"
import playStoreSVG from "../../../../static/assets/images/google_play.svg"

import footerCallSVG from "../../../../static/assets/images/icons/mob_footer_call.svg"
import onlineCallSVG from "../../../../static/assets/images/icons/mob_footer_online.svg"
import appointmentSVG from "../../../../static/assets/images/icons/mob_footer_appointment.svg"
import footerLoginSVG from "../../../../static/assets/images/icons/mob_footer_login.svg"

import { objectDeepClone } from "../../../service/helper"
import { getCookie, eraseCookie } from "../../../service/helper"

import Dropdown from 'react-bootstrap/Dropdown'

const FooterSection = () => {
	let [currentYear, setCurrentYear] = useState(null)

	useEffect(() => {
		const date = new Date()
		const year = date.getFullYear()
		setCurrentYear(year)
	}, [])

	const isUserLoggedIn = getCookie("login_id")

	const logout = () => {
		if (isUserLoggedIn) {
			eraseCookie("login_id")
			eraseCookie("user")
			eraseCookie("hh")
			navigate('/')
			if (typeof window !== "undefined") window.location.reload()
		}
	}

	const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
		<a
			href=""
			ref={ref}
			onClick={(e) => {
				e.preventDefault();
				onClick(e);
			}}
		>
			{children}
		</a>
	));

	return (
		<StaticQuery
			query={graphql`
			query footerMenu {
				allMenuItems(filter: {menu_name: {eq: "footer"}, parent: {id: {eq: null}}}) {
				  edges {
					node {
					  title
					  description
					  url
					  children {
						... on MenuItems {
						  url
						  title
						  description
						  children {
							... on MenuItems {
							  url
							  title
							  description
							}
						  }
						}
					  }
					}
				  }
				}
			  }
			  
      `}
			render={data => {
				const allMenuItems = data && data?.allMenuItems ? data.allMenuItems : []
				const column1 =
					allMenuItems && allMenuItems.edges && allMenuItems.edges[0]
						? allMenuItems.edges[0]
						: []
				const column2 =
					allMenuItems && allMenuItems.edges && allMenuItems.edges[1]
						? allMenuItems.edges[1]
						: []
				const column3 =
					allMenuItems && allMenuItems.edges && allMenuItems.edges[2]
						? allMenuItems.edges[2]
						: []

				const column3Arr =
					column3 && column3?.node?.children ? column3.node.children : []
				const col3WithChildren = column3Arr.filter(
					el => el.children && el.children.length > 0
				)
				const col3WithoutChildren = column3Arr.filter(
					el => !el.children || el.children.length === 0
				)

				const renderLink = (data, classN) => {
					const title = data && data.title ? data.title : ""
					const url = data && data.url ? data.url : ""
					const isAbsolute = url.includes("http")
					if (isAbsolute === true) {
						return (
							<a href={url} className={`${data?.description ? 'linkWithLogo ' : ''}${classN || ''}`} rel="noreferrer" target="_blank">
								{data?.description &&
									<img src={data?.description} alt={title} width="30" height="37"/>
								}
								{title}
							</a>
						)
					} else {
						return <Link to={url} className={`${data?.description ? 'linkWithLogo ' : ''}${classN || ''}`}>
							{data?.description &&
								<img src={data?.description} alt={title} width="30" height="37" />
							}
							{title}
						</Link>
					}
				}


				return (
					<>
						<footer>
							<div className="container">
								<div className="row">
									<div className="col-lg-4 col-md-4">
										{column1 &&
											column1?.node &&
											column1?.node?.children &&
											column1?.node?.children.length > 0 &&
											column1.node.children.map((el, index) => {
												return (
													<div key={index}>
														<h6 className="heading">
															{el.url &&  
																<>
																	{renderLink(el, "desktop-drop-footer")}
																	{renderLink(el, "device-drop-footer")}
																</>
															}
															{!el.url &&
																<>
																	<span className="desktop-drop-footer">
																		{el.title ? el.title : ""}
																	</span>	
																	<span
																		className={`device-drop-footer ${el?.children?.length > 0 ? "has-children" : ""}`}
																		data-toggle="collapse"
																		data-target={`#col1-${index}`}
																		aria-expanded="false"
																		aria-controls="otherproduct"
																	>
																		{el.title ? el.title : ""}
																	</span>
																</>
															}
														</h6>
														{Array.isArray(el.children) && el.children.length > 0 && (
															<ul
																className="list-unstyled collapse dont-collapse-md"
																id={`col1-${index}`}
															>
																{el.children.map((child, i) => {
																	return (
																		<li key={index + "-" + i}>
																			{renderLink(child)}
																		</li>
																	)
																})}
															</ul>
														)}
													</div>
												)
											})}
									</div>
									<div className="col-lg-4 col-md-4">
										{column2 &&
											column2?.node &&
											Array.isArray(column2?.node?.children) &&
											column2?.node?.children.length > 0 &&
											column2.node.children.map((el, index) => {
												return (
													<div key={index}>
														<h6 className="heading">
															{el.url &&  
																<>
																	{renderLink(el, "desktop-drop-footer")}
																	{renderLink(el, "device-drop-footer")}
																</>
															}
															{!el.url &&
																<>
																	<span className="desktop-drop-footer">
																		{el.title ? el.title : ""}
																	</span>	
																	<span
																		className={`device-drop-footer ${el?.children?.length > 0 ? "has-children" : ""}`}
																		data-toggle="collapse"
																		data-target={`#col2-${index}`}
																		aria-expanded="false"
																		aria-controls="otherproduct"
																	>
																		{el.title ? el.title : ""}
																	</span>
																</>
															}
														</h6>
														{el.children && el.children.length > 0 && (
															<ul
																className="list-unstyled collapse dont-collapse-md"
																id={`col2-${index}`}
															>
																{el.children.map((child, i) => {
																	return (
																		<li key={index + "-" + i}>
																			{renderLink(child)}
																		</li>
																	)
																})}
															</ul>
														)}
													</div>
												)
											})}
									</div>
									<div className="col-lg-4 col-md-4">
										{col3WithChildren.length > 0 && (
											<ul
												className="list-unstyled collapse dont-collapse-md"
												id={`footer-other-drop`}
											>
												{col3WithChildren[0].children.map((child, i) => {
													return <li key={i}>{renderLink(child)}</li>
												})}
											</ul>
										)}
										{col3WithoutChildren.length > 0 && (
											<ul className="list-unstyled alone_links">
												{objectDeepClone(col3WithoutChildren)
													.splice(0, 3)
													.map((el, index) => {
														return <li key={index}>{renderLink(el)}</li>
													})}
											</ul>
										)}
										{col3WithoutChildren.length > 0 &&
											col3WithoutChildren.length > 3 && (
												<ul className="list-unstyled alone_links">
													{objectDeepClone(col3WithoutChildren)
														.splice(3, col3WithoutChildren.length - 1)
														.map((el, index) => {
															return <li key={index}>{renderLink(el)}</li>
														})}
												</ul>
											)}
										<ul className="list-unstyled download_links">
											<li>Download the mobile app</li>
											<li>
												<a
													href="https://play.google.com/store/apps/details?id=org.pdhinduja.meet&hl=en_IN&gl=US"
													aria-label="Google Play"
													target="_blank"
													rel="noreferrer"
												>
													<img
														className="lazyload"
														data-src={playStoreSVG}
														alt="Google Play"
													/>
												</a>
												<a
													href="https://apps.apple.com/in/app/pdhh-teleconsult/id1547254383"
													aria-label="App Store"
													target="_blank"
													rel="noreferrer"
												>
													<img
														className="lazyload"
														data-src={appStoreSVG}
														alt="App Store"
													/>
												</a>
											</li>
										</ul>
										<ul className="list-unstyled follow_links">
											<li>Follow P.D. Hinduja Hospital on</li>
											<li>
												<a
													target="_blank"
													href=" https://www.linkedin.com/company/hinduja-hospital/"
													aria-label="LinkedIn"
													rel="noreferrer"
												>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="16.924"
														height="18.849"
														viewBox="0 0 16.924 18.849"
													>
														<path
															id="Icon_zocial-linkedin"
															data-name="Icon zocial-linkedin"
															d="M-.09,2.3A2.224,2.224,0,0,1,.482.727,1.931,1.931,0,0,1,1.968.108,1.875,1.875,0,0,1,3.422.717a2.339,2.339,0,0,1,.572,1.637,2.175,2.175,0,0,1-.555,1.523,1.936,1.936,0,0,1-1.5.628H1.919A1.848,1.848,0,0,1,.465,3.878,2.3,2.3,0,0,1-.09,2.3ZM.122,18.957V6.239H3.749V18.957H.122Zm5.636,0H9.385v-7.1a3.157,3.157,0,0,1,.131-1.028,2.774,2.774,0,0,1,.694-1.095,1.618,1.618,0,0,1,1.168-.447q1.83,0,1.83,2.875v6.8h3.627V11.665a6.818,6.818,0,0,0-1.144-4.274,3.718,3.718,0,0,0-6.306.657v.038H9.369l.016-.038V6.239H5.758q.033.609.033,3.789T5.758,18.957Z"
															transform="translate(0.09 -0.108)"
															fill="#024594"
														/>
													</svg>
												</a>
												<a
													target="_blank"
													href="https://www.youtube.com/user/HindujaHospitalMRC"
													aria-label="Youtube"
													rel="noreferrer"
												>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="25.408"
														height="19.97"
														viewBox="0 0 25.408 19.97"
													>
														<path
															id="Icon_simple-youtube"
															data-name="Icon simple-youtube"
															d="M24.881,5.8A3.407,3.407,0,0,0,22.67,3.309c-1.98-.6-9.951-.6-9.951-.6s-7.95-.012-9.951.6A3.407,3.407,0,0,0,.557,5.8,41.727,41.727,0,0,0,0,12.709,41.726,41.726,0,0,0,.557,19.6a3.407,3.407,0,0,0,2.211,2.487c1.978.6,9.951.6,9.951.6s7.949,0,9.951-.6A3.407,3.407,0,0,0,24.881,19.6a41.735,41.735,0,0,0,.53-6.888,41.735,41.735,0,0,0-.53-6.914ZM10.175,16.986V8.419l6.634,4.29Z"
															transform="translate(-0.004 -2.712)"
															fill="#024594"
														/>
													</svg>
												</a>
												<a
													target="_blank"
													href="https://twitter.com/HospitalHinduja"
													aria-label="Twitter"
													rel="noreferrer"
												>
													<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#024594" stroke="none"><path d="M10 4866 c0 -3 432 -570 961 -1261 528 -691 958 -1262 956 -1268 -3 -7 -407 -471 -899 -1033 -491 -561 -899 -1028 -907 -1037 -13 -16 12 -17 378 -17 l391 0 702 804 c387 443 705 805 708 805 3 1 282 -361 620 -804 l615 -804 788 -1 c433 0 787 2 787 5 0 2 -452 602 -1004 1332 l-1005 1328 28 30 c16 17 392 446 836 955 444 509 817 935 828 948 l20 22 -394 -1 -394 0 -640 -734 c-352 -404 -642 -734 -645 -735 -3 0 -255 331 -560 735 l-555 734 -807 1 c-445 0 -808 -2 -808 -4z m2770 -2282 c767 -1015 1397 -1850 1398 -1855 2 -5 -83 -9 -211 -9 l-214 0 -1409 1842 c-775 1013 -1413 1848 -1417 1855 -7 11 35 13 225 13 l233 -1 1395 -1845z"></path></g></svg>
												</a>
												<a
													target="_blank"
													href="https://www.facebook.com/HindujaHospital"
													aria-label="Facebook"
													rel="noreferrer"
												>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="12.704"
														height="23.613"
														viewBox="0 0 12.704 23.613"
													>
														<path
															id="Icon_zocial-facebook"
															data-name="Icon zocial-facebook"
															d="M6.629,12.68V8.171h3.637V5.9a5.934,5.934,0,0,1,1.593-4.18A5.068,5.068,0,0,1,15.72,0h3.613V4.51H15.72a.8.8,0,0,0-.637.39,1.582,1.582,0,0,0-.283.956V8.17h4.533V12.68H14.8V23.613H10.265V12.68Z"
															transform="translate(-6.629)"
															fill="#024594"
														/>
													</svg>
												</a>
												<a
													target="_blank"
													href="https://www.instagram.com/hindujahospital/"
													aria-label="Instagram"
													rel="noreferrer"
												>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="23.613"
														height="23.613"
														viewBox="0 0 23.613 23.613"
													>
														<path
															id="Icon_zocial-instagram"
															data-name="Icon zocial-instagram"
															d="M2.118,23.6a2.807,2.807,0,0,1-1.292-.734,2.6,2.6,0,0,1-.715-1.232C.028,21.307.024,21,.024,11.885.019,1.647.005,2.21.273,1.633A2.754,2.754,0,0,1,1.615.3c.6-.263.014-.249,10.33-.235l9.5.009.3.1a2.8,2.8,0,0,1,1.772,1.772l.1.3.009,9.5c.014,10.556.037,9.767-.3,10.45a2.741,2.741,0,0,1-1.167,1.167c-.674.332.092.309-10.353.3C3.821,23.664,2.354,23.655,2.118,23.6Zm18.391-2.81c.378-.268.388-.3.4-2.053.014-1.712,0-1.8-.277-2.072-.254-.249-.374-.263-2.044-.258l-1.523,0-.208.111a1.134,1.134,0,0,0-.341.323l-.138.2,0,1.527c0,.835.014,1.6.037,1.684a.862.862,0,0,0,.471.581l.231.115,1.6-.014,1.6-.014Zm-7.76-4.48a4.579,4.579,0,0,0,3.534-3.553,5.636,5.636,0,0,0,.051-1.5,4.647,4.647,0,0,0-2.367-3.4,4.951,4.951,0,0,0-1.218-.452c-.088-.009-.272-.037-.411-.06A4.558,4.558,0,0,0,8.222,9.112a4.514,4.514,0,0,0,.088,5.606,4.6,4.6,0,0,0,3.045,1.656A4.815,4.815,0,0,0,12.749,16.31ZM4.716,13.315a7.322,7.322,0,0,1,.609-4.683,6.787,6.787,0,0,1,1.38-1.9,7.2,7.2,0,0,1,6.279-2.049,7.309,7.309,0,0,1,5.878,5.352,7.165,7.165,0,0,1,.189,2.584,5.08,5.08,0,0,1-.189,1c-.014.023-.009.042.014.046.175.018,1.97.014,2-.009s.037-2.062.032-5.149L20.9,3.382l-.138-.2a1.153,1.153,0,0,0-.346-.3L20.2,2.773l-8.425.014L3.359,2.8,3.17,2.92a1.214,1.214,0,0,0-.3.3L2.764,3.4l-.014,5.1c0,2.805,0,5.117.009,5.144a4.965,4.965,0,0,0,1.029.046H4.8Z"
															transform="translate(-0.022 -0.058)"
															fill="#024594"
														/>
													</svg>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="copyright">
								<hr />
								<div className="container">
									<p>
										© P. D. Hinduja Hospital. All rights reserved. {currentYear}
									</p>
								</div>
							</div>
							<div
								role="button"
								aria-pressed="false"
								tabIndex="0"
								aria-label="Back to top"
								className="back-to-top"
							>
								<span className="icon"></span>
								<span className="text">Back to top</span>
							</div>
							<div className="mob_fixed_footer">
								<ul>
									<li>
										<a href="tel:022 67668181">
											<img src={footerCallSVG} alt="" />
											<span>Call Us</span>
										</a>
									</li>
									<li>
										<Link to="/online-services">
											<img src={onlineCallSVG} alt="" />
											<span>Online Services</span>
										</Link>
									</li>
									<li>
										<Link to="/book-an-appointment">
											<img src={appointmentSVG} alt="" />
											<span>Book An Appointment</span>
										</Link>
									</li>
									<li>
										{isUserLoggedIn ? (
											<Dropdown>
												<Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
													<img src={footerLoginSVG} alt="" /> <span>User</span>
												</Dropdown.Toggle>

												<Dropdown.Menu>
													<Dropdown.Item href="/user/dashboard" eventKey="1">Dashboard</Dropdown.Item>
													<Dropdown.Item href="/user/my-account" eventKey="2">My Profile</Dropdown.Item>
													<Dropdown.Item href="javascript:void(0)" onClick={logout} eventKey="3">Logout</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
										) : (
											<Link to="/user/login">
												<img src={footerLoginSVG} alt="" />
												<span>Login</span>
											</Link>
										)}
									</li>
									{/* <li>
										<a href="https://www.hindujahospital.com/khar/" rel="noreferrer" target="_blank">
											<svg width="21.008" height="21.008" viewBox="0 0 21.008 21.008" version="1.1" xmlns="http://www.w3.org/2000/svg" >
												<title>Group 6</title>
												<defs>
													<polygon id="path-1" points="0.0004 0.2513 10.675 0.2513 10.675 16 0.0004 16"></polygon>
												</defs>
												<g id="iPhone-Mockup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
													<g id="Group-6">
														<g id="Group-3" transform="translate(0.000000, 0.748500)">
															<mask id="mask-2" fill="white">
																<use href="#path-1"></use>
															</mask>
															<g id="Clip-2"></g>
															<path d="M5.3374,0.7793 C2.6854,0.7793 0.5274,2.9373 0.5274,5.5893 C0.5274,8.0153 4.6214,14.1973 5.0884,14.8943 L5.3374,15.2663 L5.5864,14.8943 C6.0534,14.1973 10.1474,8.0163 10.1474,5.5893 C10.1474,2.9373 7.9894,0.7793 5.3374,0.7793 M5.3374,16.0003 C5.2514,16.0003 5.1714,15.9573 5.1224,15.8863 C3.2194,13.1363 0.0004,7.8733 0.0004,5.5893 C0.0004,2.6463 2.3944,0.2513 5.3374,0.2513 C8.2804,0.2513 10.6754,2.6463 10.6754,5.5893 C10.6754,7.8673 7.4554,13.1333 5.5534,15.8863 C5.5044,15.9573 5.4234,16.0003 5.3374,16.0003" id="Fill-1" fill="#fff" mask="url(#mask-2)" strokeWidth="1"></path>
														</g>
														<path d="M5.3374,3.7832 C3.9284,3.7832 2.7824,4.9292 2.7824,6.3382 C2.7824,7.7462 3.9284,8.8922 5.3374,8.8922 C6.7464,8.8922 7.8924,7.7462 7.8924,6.3382 C7.8924,4.9292 6.7464,3.7832 5.3374,3.7832 M5.3374,9.4202 C3.6374,9.4202 2.2544,8.0372 2.2544,6.3382 C2.2544,4.6382 3.6374,3.2552 5.3374,3.2552 C7.0374,3.2552 8.4204,4.6382 8.4204,6.3382 C8.4204,8.0372 7.0374,9.4202 5.3374,9.4202" id="Fill-4" fill="#fff" strokeWidth="1"></path>
													</g>
												</g>
											</svg>
											<span>Khar Hospital</span>
										</a>
									</li> */}
								</ul>
							</div>
						</footer>
					</>
				)
			}}
		/>
	)
}

export default FooterSection
